module.exports = __webpack_public_path__ + "static/img/icn_tax_3d.f7e2fff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/icn_tax_3d.png
// module id = O8b4
// module chunks = 1